import modalStore from '../../../stores/modalStore';
import { useCommonNavigate } from '../../../views/common/CommonLink';
import LessonIntro from '../LessonIntro';

interface LessonIntroModalContentProps {
    modalId: string;
    lessonHash: string;
}

/**
 * 레슨 소개 모달 컨텐츠
 * - modalStore.custom으로 열어서 사용
 */
const LessonIntroModalContent = ({ modalId, lessonHash }: LessonIntroModalContentProps) => {
    const { navigate } = useCommonNavigate();

    const handleNavigate = () => {
        navigate(`/my/lesson/${lessonHash}`);
        modalStore.close(modalId);
    };

    return <LessonIntro lessonHash={lessonHash} onNavigate={handleNavigate} />;
};

export default LessonIntroModalContent;
